module.exports = __webpack_public_path__ + "static/media/logo_200.f3490e8a.png";